import { useMemo } from "react";
import { Route } from "react-router-dom";
import { SharedLayout } from "../../ui_elements";

export const SundryRouter = ({
	component,
	path,
	exact,
	purpose,
	title,
	user,
	...rest
}) => {
	const Component = component;
	const paths = useMemo(
		() => [
			{
				title: "All Bursary",
				path: "/bursary_collection/all",
				disabled: false
			},
			{
				title: "Payment History",
				path: "/sundry/payment_history",
				disabled: false
			}
		],
		[]
	);
	return (
		<Route
			exact={exact}
			path={path}
			{...rest}
			render={(props) => {
				return (
					<SharedLayout title={title} subMenus={paths}>
						<div
							style={{
								marginTop: "4.4rem"
							}}
						>
							<Component {...rest} {...props} />
						</div>
					</SharedLayout>
				);
			}}
		/>
	);
};
